import { Controller } from '@hotwired/stimulus'
export default class extends Controller {
  static values = { url: String }
  connect() {
    setTimeout(() => {
      Turbo.visit(this.urlValue, { action: 'replace' })
    }, 3000)
  }
}
